import { UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	BadgeComponent,
	DividerComponent,
	InfoGroupComponent,
	ITab,
	ModalComponent,
	TabsComponent,
	TagComponent,
} from '@tecalisdev/infinity';
import { IDocumentsDocs } from '../../../../../operations/models/operations.models';
import { LanguageService } from '../../../../../core/services/language.service';
import { WorkflowsHelperService } from '../../../../services/workflows-helper.service';
import { resolveWorkflowLocaleText } from '../../../../utils/workflow-locale-text.util';
import { TextLocalePreviewComponent } from '../../../../../shared/components/text-locale-preview/text-locale-preview.component';

@Component({
	selector: 'app-modal-doc-details',
	imports: [
		TranslatePipe,
		UpperCasePipe,
		ModalComponent,
		TabsComponent,
		InfoGroupComponent,
		TagComponent,
		DividerComponent,
		BadgeComponent,
		TextLocalePreviewComponent,
	],
	templateUrl: './modal-doc-details.component.html',
	styleUrl: './modal-doc-details.component.scss',
})
export class ModalDocDetailsComponent implements OnInit {
	@Input() doc?: IDocumentsDocs;
	@Output() closeEvent = new EventEmitter<void>();

	private workflowsHelper = inject(WorkflowsHelperService);
	private languageService = inject(LanguageService);

	public demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CUSTOM';
	public tabs: ITab[] = this.workflowsHelper.modalDocDetailsTabs;

	ngOnInit(): void {
		if (this.doc) {
			this.updateDemandLevelLabel();
		}
	}

	private updateDemandLevelLabel(): void {
		const configDoc = this.workflowsHelper.docsInfo.find((doc) => doc.type === this.doc.type)?.confRecommended;
		if (!configDoc) return;

		if (
			+configDoc.total_tries === +this.doc.total_tries &&
			+configDoc.min === +this.doc.min &&
			+configDoc.max === +this.doc.max &&
			Boolean(configDoc.preview_validation) === Boolean(this.doc.preview_validation) &&
			Boolean(configDoc.match_data) === Boolean(this.doc.match_data)
		) {
			this.demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.RECOMMENDED';
		} else {
			this.demandLevelLabel = 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CUSTOM';
		}
	}

	public resolveDocTitle(doc: IDocumentsDocs | null | undefined): string {
		if (!doc) {
			return '';
		}
		const title = resolveWorkflowLocaleText(doc.title as any, this.languageService.getLanguage(), 'es');
		if (title.trim().length > 0) {
			return title;
		}
		return `DOCS.${doc?.type}`;
	}

	public closeModal(): void {
		this.closeEvent.emit();
	}
}
